import { useNavigate } from "react-router-dom";
import { SereneHeart } from "@/lib/brand";

export default function Contact() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" style={{ backgroundColor: "#F3EEE4" }} data-testid="contact-screen">
      <div className="max-w-md space-y-6">
        <SereneHeart size={40} className="mx-auto" />
        <h1 className="font-serif text-3xl tracking-[0.24em] text-[#2E2A22]">CONTACT</h1>
        <p className="text-sm leading-relaxed text-[#6B6151]">
          For any enquiry about your membership or invitation, write to us and we will respond personally.
        </p>
        <a data-testid="contact-email" href="mailto:concierge@serenismm.com"
          className="inline-block text-[11px] tracking-[0.3em] text-[#A98F63] hover:text-[#2E2A22] uppercase">
          concierge@serenismm.com
        </a>
        <div>
          <button data-testid="contact-back" onClick={() => navigate("/")}
            className="text-[11px] tracking-[0.25em] text-[#9C907A] hover:text-[#2E2A22]">← BACK</button>
        </div>
      </div>
    </div>
  );
}
